<template>
  <div class="page-footer" :style="[wrapperStyle]">
    <div></div>
    <div class="des" v-for="item in descriptionList" :key="item.description">
      <img
        v-if="item.icon"
        class="icon"
        :style="[iconStyle]"
        :src="item.icon"
        alt=""
      />
      {{ item.description }}
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  props: {
    descriptionList: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 110
    },
    bgColor: {
      type: String,
      default: "#3C3C3C"
    },
    iconSize: {
      type: Number,
      default: 18
    }
  },
  data() {
    return {};
  },
  computed: {
    wrapperStyle() {
      return {
        height: `${this.height}px`,
        background: this.bgColor
      };
    },
    iconStyle() {
      return {
        width: `${this.iconSize}px`,
        height: `${this.iconSize}px`
      };
    }
  }
};
</script>

<style scoped lang="scss">
.page-footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/pageFooter/index.vue